var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showLabel)?_c('span',[_vm._v(_vm._s(_vm.field.label)+":")]):_vm._e(),_vm._v("\n    "+_vm._s(_vm.getFieldValue)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }